import { render, staticRenderFns } from "./PostPreview.vue?vue&type=template&id=e72ee8da&"
import script from "./PostPreview.vue?vue&type=script&lang=js&"
export * from "./PostPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports